import React from 'react';

import styles from './HeaderConversation.css';

const HeaderConversation = ({ user, theme }) => {
  let headerTheme = '';
  if (theme === 'DARK') {
    headerTheme = styles.headerDarkTheme;
  }
  
  return <div className={[styles.mainContainer, headerTheme].join(' ')}>
    <label className={styles.username}>{user.username}</label>
  </div>

}

export default HeaderConversation;


// WEBPACK FOOTER //
// ./src/pages/chat/chat-messages/message-history/header-conversation/HeaderConversation.jsx